const faqs = [
  {
    q: '51爆料网的内容来源是否可靠？',
    a: '51爆料网坚持真实性优先的原则，所有爆料内容均经过编辑团队的多重信息核实流程。平台设有专门的审核机制，对每一条发布的内容进行信息交叉验证，确保用户浏览到的是经过核实的爆料资讯。',
  },
  {
    q: '如何向51爆料网投稿爆料？',
    a: '您可以通过本站的投稿通道提交爆料信息。在投稿时请尽可能提供详细的文字描述和相关佐证材料，我们的编辑团队会在收到投稿后尽快进行审核，审核通过的爆料内容将在平台发布。',
  },
  {
    q: '51爆料网的更新频率是怎样的？',
    a: '51爆料网实行全天候不间断更新机制，编辑团队7×24小时轮值监测各类信息渠道。无论是工作日还是节假日，您都可以在平台上看到最新最热的爆料内容，平均每日更新数百条资讯。',
  },
  {
    q: '平台上的热度榜单是如何计算的？',
    a: '热度榜单综合了多个维度的数据进行实时计算，包括内容的浏览量、讨论量、分享次数以及编辑推荐等权重因素。榜单每小时自动更新一次，确保反映最新的内容热度趋势。',
  },
  {
    q: '51爆料网是否免费使用？',
    a: '是的，51爆料网对所有用户完全免费开放。您无需注册或付费即可浏览全部爆料内容。我们致力于为广大用户提供免费、便捷的爆料资讯获取渠道。',
  },
  {
    q: '如何确保个人信息在投稿时的安全性？',
    a: '我们高度重视用户隐私保护，所有投稿者的个人信息均严格保密。投稿人可选择匿名发布，平台不会在未经您明确同意的情况下公开任何个人身份信息。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 lg:px-8 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-label font-semibold text-primary-500 uppercase tracking-wider">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mt-2 mb-3">
            常见问题解答
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            关于51爆料网的常见问题，您想了解的可能都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} open className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <span className="w-6 h-6 flex items-center justify-center shrink-0 rounded-full bg-background-100 text-foreground-500 group-open:bg-primary-50 group-open:text-primary-500 transition-colors">
                  <i className="ri-arrow-down-s-line text-lg group-open:rotate-180 transition-transform"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6 -mt-1">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}